var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancialGraphIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 29,
    viewBox: "0 0 35 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.21254 13.9927C10.2754 13.9927 12.7583 11.5105 12.7583 8.44851C12.7583 5.38653 10.2754 2.9043 7.21254 2.9043C4.14968 2.9043 1.66675 5.38653 1.66675 8.44851C1.66675 11.5105 4.14968 13.9927 7.21254 13.9927Z",
    stroke: "#0A78CD",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.58427 5.27539H6.82935V6.45583H7.58427V5.27539Z",
    fill: "#0A78CD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.58427 10.4707H6.82935V11.6221H7.58427V10.4707Z",
    fill: "#0A78CD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.20071 10.8384C6.83292 10.8384 6.52321 10.7707 6.26189 10.6352C6.00057 10.4998 5.77796 10.3063 5.57471 10.0547L6.09736 9.53219C6.22318 9.71603 6.37803 9.86117 6.55225 9.9676C6.72646 10.074 6.95874 10.1224 7.22974 10.1224C7.49106 10.1224 7.69431 10.074 7.83949 9.9676C7.99435 9.86117 8.07177 9.71603 8.07177 9.53219C8.07177 9.37738 8.03306 9.2516 7.95563 9.15484C7.8782 9.05808 7.77174 8.98067 7.63624 8.91294C7.50074 8.84521 7.36524 8.78716 7.20071 8.73878C7.04585 8.6904 6.89099 8.63235 6.72645 8.56462C6.5716 8.49689 6.42642 8.41948 6.29092 8.32272C6.15542 8.22596 6.05864 8.10018 5.97153 7.94537C5.8941 7.79056 5.85539 7.59704 5.85539 7.35515C5.85539 7.08422 5.92313 6.84233 6.05863 6.65849C6.19413 6.46498 6.37803 6.31984 6.61032 6.21341C6.8426 6.10697 7.09424 6.05859 7.3846 6.05859C7.69431 6.05859 7.9653 6.11665 8.20727 6.24243C8.44923 6.35854 8.6428 6.51335 8.79766 6.69719L8.27502 7.21969C8.13952 7.06487 8.00402 6.95844 7.85884 6.88103C7.71366 6.80363 7.54913 6.7746 7.36524 6.7746C7.13295 6.7746 6.95874 6.82298 6.82324 6.91006C6.68775 7.00682 6.62968 7.1326 6.62968 7.29709C6.62968 7.44223 6.66839 7.54866 6.74581 7.63574C6.82324 7.72283 6.92971 7.79056 7.06521 7.85829C7.19103 7.91634 7.3362 7.9744 7.50074 8.03245C7.66527 8.0905 7.81046 8.14856 7.97499 8.21629C8.12985 8.28402 8.27502 8.3711 8.41052 8.46786C8.53634 8.57429 8.64281 8.70975 8.72991 8.87424C8.80734 9.03873 8.84605 9.24192 8.84605 9.49349C8.84605 9.90955 8.70088 10.2385 8.40085 10.4804C8.11049 10.7223 7.70398 10.8481 7.21038 10.8481L7.20071 10.8384Z",
    fill: "#0A78CD"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.38789 16.3926H10.0789C10.5918 16.3926 10.9983 16.8086 10.9983 17.3118V28.0809H3.35229V17.4182C3.35229 16.8473 3.81686 16.3926 4.37822 16.3926H4.38789Z",
    fill: "#00E2BC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16.0261 11.6113H21.717C22.23 11.6113 22.6365 12.0274 22.6365 12.5305V28.0891H14.9905V12.6466C14.9905 12.0758 15.455 11.621 16.0164 11.621L16.0261 11.6113Z",
    fill: "#00E2BC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M27.7228 0.911133H33.4138C33.9268 0.911133 34.3333 1.32719 34.3333 1.83033V28.0807H26.6873V1.94644C26.6873 1.37557 27.1518 0.920809 27.7132 0.920809L27.7228 0.911133Z",
    fill: "#00E2BC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M21.6748 28.0804H15.0063V13.6055",
    stroke: "#0A78CD",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M20.5518 25.2446V13.624",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M8.83911 25.6144V18.0576",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M33.4525 28.0807H26.6873V2.91406",
    stroke: "#0A78CD",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M32.2699 25.2456V2.9043",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M10.0313 28.0809H3.36279V18.3857",
    stroke: "#0A78CD",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialGraphIcon);
export default __webpack_public_path__ + "static/media/FinancialGraphIcon.9a70dfcbf89efed7358f988b11254f0a.svg";
export { ForwardRef as ReactComponent };